import { render, staticRenderFns } from "./ProductPartsList.vue?vue&type=template&id=b0dbaa28&scoped=true&lang=pug&"
import script from "./ProductPartsList.vue?vue&type=script&lang=ts&"
export * from "./ProductPartsList.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPartsList.vue?vue&type=style&index=0&id=b0dbaa28&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dbaa28",
  null
  
)

export default component.exports